export default {
	mkao 			  		: require('./../images/melodiekao.jpg'),
	burger  				: require('./../images/burger.svg'),
	mkao_c09_20150828 		: require('./../images/RESEARCH_c09_20150828.png'),
	placeholder 	  		: require('./../images/placeholder.jpg'),
	FIG_allAgeEvol_revisedb : require('./../images/RESEARCH_allAgeEvol_revisedb.png'),
	planetaryMass			: require('./../images/RESEARCH_planetaryMass.jpg'),
	ydwarf_radioLuminosity  : require('./../images/RESEARCH_ydwarf_radioLuminosity.jpeg'),
	decadal					: require('./../images/RESEARCH_astro2020.jpg'),
	occurrence				: require('./../images/RESEARCH_occurrenceRate.jpg'),
	kao2022					: require('./../images/RESEARCH_binaries.png'),
	occurrenceBinary		: require('./../images/RESEARCH_occurrenceRateBinary.jpg'),
	richeyyowell2020 		: require('./../images/RESEARCH_richeyyowell2020.jpg'),
	flipped					: require('./../images/TEACH_flippedclassroom.png'),
	e110					: require('./../images/TEACH_e110.png'),
	wildAstro				: require('./../images/TEACH_wildAstro.jpg'),
	neutronStar				: require('./../images/TEACH_neutronStar.png'),
	tango					: require('./../images/TEACH_yuliClass.png'),
	skurka					: require('./../images/TEACH_skurka.jpg'),
	boundaries				: require('./../images/TOOLKIT_valuesCompass.jpg'),
	boundariesII			: require('./../images/TOOLKIT_valuesCompass_interpersonal.jpg'),
	simp0136_pressRelease   : require('./../images/NEWS_simp0136_pressRelease.jpg'),
	hubbleFellow			: require('./../images/NEWS_hubbleFellow.png'),
	backpacker				: require('./../images/NEWS_backpackerMagazine.png'),
	pi_launchpad			: require('./../images/NEWS_PI-Launchpad.jpg'),
	decadal_earlyCareer     : require('./../images/NEWS_decadal_earlyCareer.jpg'),
	wildAstro_article		: require('./../images/NEWS_20191213_wildAstro.jpg'),
	pegb_fellow				: require('./../images/NEWS_51pegbFellow.png'),	
	skurka_insta			: require('./../images/NEWS_melodie_outside.JPG'),
	hex1					: require('./../images/NEWS_hex1.png'),
	hex2					: require('./../images/NEWS_hex2.png'),
	aac 					: require('./../images/NEWS_aac.png'),
	cs21 					: require('./../images/NEWS_cs21.png'),
} 



// WEBPACK FOOTER //
// ./src/config/images.js